<template>
  <div class="host vm-button-wrap">
    <button
      @click="$emit('click')"
      :type="type"
      class="vm-button-base"
      :class="this.classes"
    >
      <span class="vm-button-overlay"></span>
      <span class="vm-button-wrapper">
        <slot />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    vmButton: {
      type: Boolean,
      default: false
    },
    vmRaisedButton: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'base'
    }
  },
  computed: {
    classes: function() {
      return [
        `vm-${this.color}`,
        {
          'vm-raised-button': this.vmRaisedButton
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #6280bd;
$danger-color: #dc343d;
$light-color: white;

.vm-button-base {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  padding: 0 1rem;
  text-transform: uppercase;
  border-radius: 4px;
  border: 0;
  outline: none;
  background-color: transparent;
  height: 36px;
  line-height: 36px;
  overflow: hidden;
}
.vm-button-base .vm-button-wrapper {
  line-height: 36px;
}
.vm-button-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  transition: background-color 200ms ease;
}
.vm-button-base:focus .vm-button-overlay,
.vm-button-base:hover .vm-button-overlay {
  background-color: rgba(0, 0, 0, 0.05);
}
.vm-raised-button {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.vm-raised-button .vm-button-overlay {
  display: none;
}
.vm-primary {
  background-color: $primary-color;
  color: $light-color;
}
.vm-danger {
  background-color: $danger-color;
  color: $light-color;
}
</style>
